import { apiFetch, apiUrl, isSuccess } from "./apiClient";
import { emitBookmarksChanged } from "./bookmarksEvents";

export async function getBookmarks() {
  const fetchResults = await apiFetch(apiUrl("/bookmarks/getUserBookmarks"));

  if (isSuccess(fetchResults)) {
    return fetchResults.json();
  }
}

export async function addBookmark(bookmark) {
  const fetchResults = await apiFetch(apiUrl("/bookmarks/addUserBookmarks"), {
    option: "POST",
    body: bookmark,
  });

  if (isSuccess(fetchResults)) {
    emitBookmarksChanged();
    return fetchResults.json();
  }
}

export async function deleteBookmark(bookmark) {
  const fetchResults = await apiFetch(
    apiUrl(`/bookmarks/deleteUserBookmarks/${bookmark.bookmark_id}`),
    { option: "DELETE" },
  );

  if (isSuccess(fetchResults)) {
    emitBookmarksChanged();
    return fetchResults.json();
  }
}

// Whether the current user has favorited (bookmarked) a given page url.
// Returns a boolean; resolves false (never throws) so a failed read renders a
// neutral, un-favorited heart.
export async function isBookmarked(pageUrl) {
  try {
    const fetchResults = await apiFetch(
      apiUrl(`/bookmarks/isBookmarked?url=${encodeURIComponent(pageUrl)}`),
    );
    if (!isSuccess(fetchResults)) {
      return false;
    }
    const body = await fetchResults.json();
    return Boolean(body?.isBookmarked);
  } catch (error) {
    console.error("isBookmarked error:", error);
    return false;
  }
}

// Toggle the favorite (bookmark) for a page: adds it if missing, removes it if
// present. `bookmark` is { url, title?, subcategory? }. Returns the new state
// as a boolean, or null on failure so the caller can roll back an optimistic
// update.
export async function toggleBookmark(bookmark) {
  try {
    const fetchResults = await apiFetch(apiUrl("/bookmarks/toggle"), {
      option: "POST",
      body: bookmark,
    });
    if (!isSuccess(fetchResults)) {
      return null;
    }
    const body = await fetchResults.json();
    emitBookmarksChanged();
    return Boolean(body?.isBookmarked);
  } catch (error) {
    console.error("toggleBookmark error:", error);
    return null;
  }
}
